import { useState, useEffect } from 'react';

const useSessionStorage = (key, defaultValue) => {
  const [value, setValue] = useState(() => {
    const item = sessionStorage.getItem(key);
    return item ? JSON.parse(item) : defaultValue;
  });

  useEffect(() => {
    sessionStorage.setItem(key, JSON.stringify(value));
  }, [key, value]);

  return [value, setValue];
};

export default useSessionStorage;
